import React, { useEffect, useState } from 'react';
import { Modal, ModalCancelButton, ModalConfirmButton } from '../Modal';
import { DELETE_CONFIRM_MODAL } from '../../helpers/globalConstants';
import { useMutation } from '@tanstack/react-query';
import { Toaster } from '../../helpers/toaster';
import { refetchQuery } from '../../helpers/events';

const initialState = {
  message: 'Are you sure you want to delete this record ?',
  title: 'Please confirm',
  show: false,
  refetchQueryKey: '',
  mutationFn: () => {},
  apiPayload: null,
  confirmCb: null,
  cancelCb: null,
};

export const DeleteConfirmModal = () => {
  const [state, setState] = useState(initialState);

  const {
    message,
    title,
    show,
    apiPayload,
    mutationFn,
    refetchQueryKey = '',
    confirmCb,
    cancelCb,
  } = state;

  const handleEvent = ({ detail }) => {
    setState((prev) => {
      return {
        ...prev,
        mutationFn: detail?.mutationFn ?? prev.mutationFn,
        message: detail?.message ?? prev.message,
        title: detail?.title ?? prev.title,
        apiPayload: detail?.apiPayload,
        refetchQueryKey: detail?.refetchQueryKey,
        show: true,
        confirmCb: detail?.confirmCb,
        cancelCb: detail?.cancelCb,
      };
    });
  };

  const resetState = () => setState(initialState);

  const { mutate, isPending } = useMutation({
    mutationKey: mutationFn.name || 'mutationKey',
    mutationFn: mutationFn || '',
    onSuccess: ({ data }) => {
      Toaster.success(data?.data?.[0]?.msg || 'Record Deleted Successfully');
      if (confirmCb) {
        confirmCb();
      }
      resetState();
      if (refetchQueryKey)
        document.dispatchEvent(refetchQuery(refetchQueryKey));
    },
    onError: (error) => {
      resetState();
    },
  });

  // registering event for delete a record confirm modal
  useEffect(() => {
    document.addEventListener(DELETE_CONFIRM_MODAL, handleEvent);

    return () => {
      document.removeEventListener(DELETE_CONFIRM_MODAL, handleEvent);
    };
  }, []);

  return (
    <>
      {show ? (
        <Modal
          shouldCloseOnClickOutside={true}
          title={title}
          handleClose={resetState}
          width="sm"
          height="250"
          footerComponent={
            <div className="gap--sm d--flex w--full">
              <ModalCancelButton
                cb={() => {
                  if (cancelCb) {
                    cancelCb();
                  }
                  resetState();
                }}
              />
              <ModalConfirmButton
                cb={() => {
                  mutate(apiPayload ?? {});
                }}
                label={isPending ? 'Please wait...' : 'OK'}
                variant="danger"
              />
            </div>
          }
        >
          {message}
        </Modal>
      ) : (
        <></>
      )}
    </>
  );
};
